//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */

/* eslint-disable */
// ReSharper disable InconsistentNaming
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IBaseDataClient {
  /**
   * Gibt alle Vorhabenprogramme zurück
   * @return Vorhabenprogramme
   */
  getVorha(): Observable<ApiVorhabenprogramm[]>;
  /**
   * Gibt alle Monate zurück
   * @return Vorhabenprogramme
   */
  getMonat(): Observable<ApiMonat[]>;
}

@Injectable()
export class BaseDataClient implements IBaseDataClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Gibt alle Vorhabenprogramme zurück
   * @return Vorhabenprogramme
   */
  getVorha(): Observable<ApiVorhabenprogramm[]> {
    let url_ = this.baseUrl + '/api/BaseData/Vorhabenprogramme';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVorha(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVorha(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiVorhabenprogramm[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiVorhabenprogramm[]>;
        })
      );
  }

  protected processGetVorha(response: HttpResponseBase): Observable<ApiVorhabenprogramm[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiVorhabenprogramm[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gibt alle Monate zurück
   * @return Vorhabenprogramme
   */
  getMonat(): Observable<ApiMonat[]> {
    let url_ = this.baseUrl + '/api/BaseData/Monat';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMonat(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMonat(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiMonat[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiMonat[]>;
        })
      );
  }

  protected processGetMonat(response: HttpResponseBase): Observable<ApiMonat[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiMonat[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IForecastClient {
  /**
   * Gibt alle Forecast-Daten inkl. Werte zurück
   * @param year (optional) Year
   * @return Forecastdaten
   */
  get(year: number | undefined): Observable<ApiForecast[]>;
  /**
   * Gibt eine Liste an Jahren von MinJahr bis aktuelles Jahr +2 zurück
   * @return Jahre
   */
  getYears(): Observable<number[]>;
  /**
   * Speichert Forecast als neuer FC(X+1) solange die Werte nicht identisch mit dem FCX sind
   * @param fc Liste von Forecast-Objecten
   * @return Forecastdaten
   */
  save(fc: ApiForecastSave[]): Observable<ApiForecast[]>;
  /**
   * Aktualisiert die Aktuell_Flag
   * @param fc Liste von aktuellen Forecast-Objecten
   * @return Forecastdaten
   */
  updateCurrent(fc: ApiForecastUpdate[]): Observable<ApiForecast[]>;
  /**
   * Gibt alle Vorhabenprogramme mit Liste an zugehörigen Forecasts für ein Jahr zurück
   * @param year (optional) Year
   * @return Forecastdaten
   */
  getAllVorhabenprogrammFc(year: number | undefined): Observable<ApiVorhabenprogrammForecasts[]>;
}

@Injectable()
export class ForecastClient implements IForecastClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * Gibt alle Forecast-Daten inkl. Werte zurück
   * @param year (optional) Year
   * @return Forecastdaten
   */
  get(year: number | undefined): Observable<ApiForecast[]> {
    let url_ = this.baseUrl + '/api/Forecast/GetAsync?';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiForecast[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiForecast[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiForecast[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiForecast[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gibt eine Liste an Jahren von MinJahr bis aktuelles Jahr +2 zurück
   * @return Jahre
   */
  getYears(): Observable<number[]> {
    let url_ = this.baseUrl + '/api/Forecast/GetYearsAsync';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetYears(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetYears(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number[]>;
            }
          } else return _observableThrow(response_) as any as Observable<number[]>;
        })
      );
  }

  protected processGetYears(response: HttpResponseBase): Observable<number[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Speichert Forecast als neuer FC(X+1) solange die Werte nicht identisch mit dem FCX sind
   * @param fc Liste von Forecast-Objecten
   * @return Forecastdaten
   */
  save(fc: ApiForecastSave[]): Observable<ApiForecast[]> {
    let url_ = this.baseUrl + '/api/Forecast/SaveAsync';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(fc);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSave(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSave(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiForecast[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiForecast[]>;
        })
      );
  }

  protected processSave(response: HttpResponseBase): Observable<ApiForecast[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiForecast[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as Anonymous[]);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Aktualisiert die Aktuell_Flag
   * @param fc Liste von aktuellen Forecast-Objecten
   * @return Forecastdaten
   */
  updateCurrent(fc: ApiForecastUpdate[]): Observable<ApiForecast[]> {
    let url_ = this.baseUrl + '/api/Forecast/UpdateCurrentAsync';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(fc);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCurrent(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCurrent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiForecast[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiForecast[]>;
        })
      );
  }

  protected processUpdateCurrent(response: HttpResponseBase): Observable<ApiForecast[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiForecast[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as Anonymous2[]);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gibt alle Vorhabenprogramme mit Liste an zugehörigen Forecasts für ein Jahr zurück
   * @param year (optional) Year
   * @return Forecastdaten
   */
  getAllVorhabenprogrammFc(year: number | undefined): Observable<ApiVorhabenprogrammForecasts[]> {
    let url_ = this.baseUrl + '/api/Forecast/GetAllVorhabenprogrammFcAsync?';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllVorhabenprogrammFc(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllVorhabenprogrammFc(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiVorhabenprogrammForecasts[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ApiVorhabenprogrammForecasts[]>;
        })
      );
  }

  protected processGetAllVorhabenprogrammFc(
    response: HttpResponseBase
  ): Observable<ApiVorhabenprogrammForecasts[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ApiVorhabenprogrammForecasts[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

/** Basis für alle API Objekte mit Guid. */
export interface ApiEntity {
  /** Unique Guid-ID */
  guid: string;
}

/** Api Vorhabenprogramm Modell */
export interface ApiVorhabenprogramm extends ApiEntity {
  /** Unique ID / VorhabenprogrammNr */
  id: string;
  /** Die Bezeichnung des Vorhabenprogramms */
  vProgramm: string;
}

/** Das Apimodell für den Forecast */
export interface ApiMonat {
  /** Der Monat */
  id: MonthType;
  /** Der Name des Monats */
  name: string;
}

/** Auflistung aller Monate */
export enum MonthType {
  Default = 0,
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}

/** Das Apimodell für den Forecast */
export interface ApiForecast extends ApiEntity {
  /** Das Jahr */
  jahr: number;
  /** Die VohabenprogrammNr */
  vorhabenprogrammId: string;
  /** Das Vorhabenprogramm */
  vProgramm: string;
  /** ForecastName (zählt innerhalb von Jahr und Vorhabenprogramm von FC0 hoch) */
  forecastName: string;
  /** Flag, welcher Datensatz aktuell ist -> genau einer je Jahr und Vorhabenprogramm */
  aktuellFlag: boolean;
  /** Liefert Liste mit den 12 Forecastwerten zum Forecast */
  forecastWerte: ApiForecastValues[];
}

export interface ApiForecastValues {
  /** FK Id zum Monat */
  monatId: MonthType;
  /** Forecast-Wert, der im Frontend geplant wird */
  forecastWert?: number | undefined;
}

/** Das Apimodell zum Speichern des Forecasts */
export interface ApiForecastSave {
  /** Das Jahr */
  jahr: number;
  /** Die VohabenprogrammNr */
  vorhabenprogrammId: string;
  /** Liefert Liste mit den 12 Forecastwerten zum Forecast */
  forecastWerte: ApiForecastValues[];
}

/** Das Apimodell für den Forecast */
/** Das Jahr */
export interface ApiForecastUpdate extends ApiEntity {
  jahr: number;
  /** Die VohabenprogrammNr */
  vorhabenprogrammId: string;
}

/** Das Apimodell für den Forecast */
export interface ApiVorhabenprogrammForecasts {
  /** Das Jahr */
  jahr: number;
  /** Die VohabenprogrammNr */
  vorhabenprogrammId: string;
  /** Das Vorhabenprogramm */
  vProgramm: string;
  /** Liefert Liste mit den zugehörigen Forecasts */
  forecastList: ApiForecastList[];
}

/** Das Apimodell für den Forecast */
export interface ApiForecastList extends ApiEntity {
  /** ForecastName (zählt innerhalb von Jahr und Vorhabenprogramm von FC0 hoch) */
  forecastName: string;
  /** Flag, welcher Datensatz aktuell ist -> genau einer je Jahr und Vorhabenprogramm */
  aktuellFlag: boolean;
}

export interface Anonymous {
  [key: string]: any;
}

export interface Anonymous2 {
  [key: string]: any;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
